import React from 'react';
import Image from 'next/image';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-clay/20 py-10 bg-parchment">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo + copyright */}
          <div className="flex items-center gap-6">
            <Image
              src="/assets/logo.png"
              alt="CorsAsia Logo"
              width={80}
              height={61}
              className="h-8 w-auto object-contain"
            />
            <span className="text-charcoal/30 hidden md:block">·</span>
            <p className="text-sm text-charcoal/40 font-sans">
              © 2026 CorsAsia. Tous droits réservés.
            </p>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-8">
            <a
              href="/#story"
              className="text-sm text-charcoal/50 hover:text-charcoal transition-colors font-medium"
            >
              Notre Histoire
            </a>
            <a
              href="/#menu"
              className="text-sm text-charcoal/50 hover:text-charcoal transition-colors font-medium"
            >
              La Carte
            </a>
            <a
              href="/#locations"
              className="text-sm text-charcoal/50 hover:text-charcoal transition-colors font-medium"
            >
              Nos Points de Vente
            </a>
            <a
              href="/#contact"
              className="text-sm text-charcoal/50 hover:text-charcoal transition-colors font-medium"
            >
              Contact
            </a>
          </nav>

          {/* Social */}
          {/*<div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/corsasia"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram CorsAsia"
              className="w-9 h-9 rounded-full border border-clay/30 flex items-center justify-center text-charcoal/50 hover:text-charcoal hover:border-clay transition-all"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/corsasia"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook CorsAsia"
              className="w-9 h-9 rounded-full border border-clay/30 flex items-center justify-center text-charcoal/50 hover:text-charcoal hover:border-clay transition-all"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
          </div>
          */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;